import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

/**
 * One of the two ways to get invoices to us, numbered.
 *
 * The number is the same marker the checklist uses for a step that is not started, so
 * the page reads in the language the rest of onboarding already speaks. It counts the
 * routes rather than ordering them: either one on its own is enough, and most customers
 * end up doing both.
 */
export const RouteHeading = ({
  number,
  title,
  detail,
}: {
  number: number;
  title: string;
  detail: string;
}) => (
  <Stack className="w-full" direction="row" gap={2} align="start">
    <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full border border-line">
      <Text weight="semibold" variant="caption" tone="muted">
        {number}
      </Text>
    </span>
    <Stack className="w-full" align="start" gap={0}>
      <Text variant="title">{title}</Text>
      <Text tone="muted">{detail}</Text>
    </Stack>
  </Stack>
);
